import React from 'react';
import { Grid, TextField } from '@mui/material';
import { Formik, FormikProps } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { OnboardingAction, OnboardingState } from '../onboarding.types';
import { ICreateSchoolRequestDto } from '../../../apis/models/schools';

interface Step1Props {
  state: OnboardingState;
  dispatch: React.Dispatch<OnboardingAction>;
  formikRef: React.RefObject<FormikProps<any>>;
  onNext: () => void;
}

const schema = Yup.object({
  name: Yup.string().required('School name is required'),
  address: Yup.string().required('Address is required'),
  country: Yup.string().required('Country is required'),
  phone: Yup.string().required('Phone is required'),
});

const Step1_SchoolProfile: React.FC<Step1Props> = ({ state, dispatch, formikRef, onNext }) => {
  const { t } = useTranslation();

  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        name: (state.school as any)?.schoolName || '',
        address: (state.school as any)?.address || '',
        country: (state.school as any)?.country || '',
        phone: (state.school as any)?.phone || '',
      }}
      validationSchema={schema}
      onSubmit={(values) => {
        dispatch({
          type: 'SET_SCHOOL',
          payload: { schoolName: values.name, classrooms: [] } as ICreateSchoolRequestDto,
        });
        onNext();
      }}
    >
      {({ errors, handleBlur, handleChange, touched, values }) => (
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label={t('school_name_label')}
                name="name"
                value={values.name}
                onBlur={handleBlur}
                onChange={handleChange}
                error={Boolean(touched.name && errors.name)}
                helperText={touched.name ? String(errors.name || '') : ''}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Address"
                name="address"
                value={values.address}
                onBlur={handleBlur}
                onChange={handleChange}
                error={Boolean(touched.address && errors.address)}
                helperText={touched.address ? String(errors.address || '') : ''}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Country"
                name="country"
                value={values.country}
                onBlur={handleBlur}
                onChange={handleChange}
                error={Boolean(touched.country && errors.country)}
                helperText={touched.country ? String(errors.country || '') : ''}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label={t('cellNumber_label')}
                name="phone"
                value={values.phone}
                onBlur={handleBlur}
                onChange={handleChange}
                error={Boolean(touched.phone && errors.phone)}
                helperText={touched.phone ? String(errors.phone || '') : ''}
              />
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
};

export default Step1_SchoolProfile;
